<template>
  <q-form ref="editForm">
    <c-card title="기본정보" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline >
          <!-- [S]결재관련 버튼 -->
          <!-- sysApprovalRequestId: 상세조회시 관련 결재요청일련번호 확인 -->
          <!-- popupParam.isApprContent: 결재요청/결재처리 팝업의 component에 해당 페이지 호출시 true -->
          <!-- approvalStatusCd: 결재요청건에 대한 상태코드 -->
          <!-- popupParam.approvalDocType: TODO(결재할문서에서 상세페이지호출시) -->
          <c-appr-btn 
            ref="appr-btn"
            name="danger-journal-appr-btn"
            :editable="editable"
            :approvalInfo="approvalInfo"
            @beforeApprAction="saveDataAppr"
            @callbackApprAction="approvalCallback"
            @requestAfterAction="getDetail"
          />
          <c-btn v-if="editable && !disabled && isRemove" label="삭제" :editable="editable" icon="delete_forever" @btnClicked="removeData" />
          <c-btn
            v-if="editable && !disabled"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="data"
            :mappingType="saveType"
            label="저장"
            icon="save"
            @beforeAction="saveJournal"
            @btnCallback="saveCallback" 
          />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-text
            required
            :editable="editable"
            :disabled="disabled"
            label="취급일지명"
            name="envDangerTitle"
            v-model="data.envDangerTitle">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-text
            required
            :readonly="true"
            :editable="editable"
            label="품명(위험물저장소)"
            name="envDangerMstName"
            v-model="data.envDangerMstName"
            @searchDangerMaster="searchDangerMaster"
            @removeDangerMaster="removeDangerMaster"
            :afterIcon="disabled  || updateMode ? null :[
              { name: 'search', click: true, callbackName: 'searchDangerMaster' },
              { name: 'close', click: true, callbackName: 'removeDangerMaster' }
            ]">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 기간 -->
          <c-datepicker
            required
            :range="true"
            name="period"
            :disabled="disabled || updateMode"
            defaultStart="0d"
            defaultEnd="6d"
            label="기간"
            v-model="period"
            @datachange="gridchange"
          ></c-datepicker>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant 
            required
            :editable="editable" 
            :disabled="disabled"
            type="edit" 
            name="plantCd" 
            v-model="data.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-text
            :disabled="true"
            :editable="editable"
            label="설치장소"
            name="envDangerArea"
            v-model="data.envDangerArea">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-text
            :editable="editable"
            :disabled="true"
            label="지정수량"
            name="envDangerCount"
            v-model="data.envDangerCount">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-text
            :editable="editable"
            :disabled="true"
            label="주용도"
            name="envDangerMainUse"
            v-model="data.envDangerMainUse">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-multi-field
            :editable="editable"
            :data="data"
            :disabled="disabled"
            label="안전관리자"
            type="user"
            name="envDangerManageUserId"
            v-model="data.envDangerManageUserId">
          </c-multi-field>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-multi-field
            :editable="editable"
            :data="data"
            :disabled="disabled"
            label="담당자"
            type="user"
            name="envDangerUserId"
            v-model="data.envDangerUserId">
          </c-multi-field>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-multi-field
            :editable="editable"
            :data="data"
            :disabled="disabled"
            label="안전대리자"
            type="user"
            name="envDangerSafetyUserId"
            v-model="data.envDangerSafetyUserId">
          </c-multi-field>
        </div>
      </template>
    </c-card>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-tab
        type="tabcard"
        :tabItems.sync="tabItems"
        :inlineLabel="true"
        v-model="tab"
        align="left"
      >
        <template v-slot:default="tab">
          <component
            :is="tab.component"
            :data="data"
            :itemGrid.sync="itemGrid"
            :prevList.sync="prevList"
            :resultGrid.sync="resultGrid"
            :contentHeight="contentHeight"
            @getDetail="getDetail"
          />
        </template>
      </c-tab>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'danger-journal-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        envDangerJournalId: '',
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      editable: true,
      searchUrl: '',
      itemGrid: {
        columns: [
        ],
        height: '450px'
      },
      data: {
        envDangerJournalId: '',
        plantCd: '',
        envDangerMstId: '',
        envDangerTitle: '',
        envDangerStartDate: '',
        envDangerEndDate: '',
        envDangerArea: '',
        envDangerManageUserId: '',
        envDangerMstName: '',
        envDangerUserId: '',
        envDangerSafetyUserId: '',
        envDangerCount: '',
        envDangerMainUse: '',
        envDangerCompleteFlag: '',
        approvalStatusCd: '', // 결재관련 결재상태
        sysApprovalRequestId: '', // 결재관련 결재요청코드

        itemList: [],
        resultList: [],
        imprList: [],
      },
      period: [],
      tab: 'dangerJournalResult',
      tabItems: [
        { name: 'dangerJournalResult', icon: 'list', label: '취급일지 결과', component: () => import(`${'./dangerJournalResult.vue'}`) },
        { name: 'dangerJournalItem', icon: 'list', label: '점검항목', component: () => import(`${'./dangerJournalItem.vue'}`) },
        { name: 'dangerJournalImpr', icon: 'health_and_safety', label: '개선관리', component: () => import(`${'./dangerJournalImpr.vue'}`) },
      ],
      resultGrid: {
        merge: [
          { index: 0, colName: 'envDangerResultDate' },
        ],
        columns: [
          {
            name: 'envDangerResultDate',
            field: 'envDangerResultDate',
            label: '날짜',
            align: 'center',
            style: 'width:150px',
            sortable: false,
            fix: true,
          },
          {
            name: 'envDangerResultName',
            field: 'envDangerResultName',
            label: '저장소구분/저장품목',
            align: 'center',
            style: 'width:150px',
            sortable: false,
            fix: true,
          },
          {
            name: 'envDangerIn',
            field: 'envDangerIn',
            label: '입고량(L)',
            align: 'right',
            type: 'number',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'envDangerOut',
            field: 'envDangerOut',
            label: '사용량(L)',
            align: 'right',
            type: 'number',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'envDangerStock',
            field: 'envDangerStock',
            label: '재고량(L)',
            align: 'right',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'envDangerQuan',
            field: 'envDangerQuan',
            label: '지정수량(L)',
            align: 'right',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'calcuMethod',
            field: 'calcuMethod',
            label: '계산방식',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            setHeader: true,
            name: 'envDangerConfirmUserName',
            field: 'envDangerConfirmUserName',
            label: '확인자',
            align: 'center',
            type: 'user',
            userId: 'envDangerConfirmUserId',
            style: 'width:150px',
            sortable: false,
          },
          {
            setHeader: true,
            name: 'remark',
            field: 'remark',
            label: '비고',
            align: 'center',
            type: 'textarea',
            style: 'width:200px',
            sortable: false,
          },
        ],
        prevData: [],
        height: '450px'
      },
      saveUrl: 'transactionConfig.env.danger.journal.insert.url',
      saveType: 'POST',
      isSave: false,
      getUrl: '',
      insertUrl: '',
      deleteUrl: '',
      updateUrl: '',
      updateMode: false,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      resDate: [],
      prevList: [],
      isApproval: false,
    };
  },
  computed: {
    approvalInfo() {
      return {
        sysApprovalRequestId: this.data.sysApprovalRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.data.approvalStatusCd, 
        apprEditable: this.data.envDangerCompleteFlag && this.data.envDangerCompleteFlag !== 'Y', // 결재버튼 활성화 기준
        param: this.data, // 결재 param
        approvalUrl: this.updateUrl, // 결재 url
        isApproval: this.isApproval, // 결재 submit
        approvalTypeCd: 'APTC000010', // 결재유형코드
        approvalParamValue: { // 결재상세화면 파라미터
          envDangerJournalId: this.data.envDangerJournalId,
          isApprContent: true
        },
        approvalRequestName: '위험물 취급일지 ['+this.data.envDangerTitle+']', // 결재요청명 (문서 title)
        approvalConnId: this.popupParam.envDangerJournalId, // 결재연결용 업무일련번호 (문서 key)
      }
    },
    disabled() {
     return this.data.envDangerCompleteFlag === 'Y' || this.data.approvalStatusCd === 'ASC0000001'
    },
    isRemove() {
      return this.popupParam.envDangerJournalId && Boolean(!this.data.sysApprovalRequestId)
    },
  },
  watch: {
    contentHeight() {
      let height = (this.contentHeight - 240);
      if (height < 400) {
        height = 500;
      }
      this.itemGrid.height = height + 'px'
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.env.danger.journal.result.url;
      this.getUrl = selectConfig.env.danger.journal.get.url;
      this.insertUrl = transactionConfig.env.danger.journal.insert.url;
      this.updateUrl = transactionConfig.env.danger.journal.update.url;
      this.deleteUrl = transactionConfig.env.danger.journal.delete.url;
      // list setting
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.envDangerJournalId) {
        this.$http.url = this.$format(this.getUrl, this.popupParam.envDangerJournalId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.updateMode = true;
          this.data = this.$_.clone(_result.data);
          this.period = [_result.data.envDangerStartDate, _result.data.envDangerEndDate];
          if (_result.data.itemList) {
            this.$_.forEach(_result.data.itemList, _item => {
              this.$_.forEach(_item.itemResultList, __item => {
                _item[__item.envDangerItemDate] = __item.envDangerEvalCd
              })
            })
          }
          this.gridchange();
          this.getPrevDetail();
        },);
      } else {
        this.gridchange();
      }
    },
    getPrevDetail() {
      if (!this.period) return;
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        prevDate: this.period[0],
        envDangerMstId: this.data.envDangerMstId,
      }
      this.$http.request((_result) => {
        this.prevList = []
        if (this.data.resultList) {
          this.$_.forEach(_result.data, _item => {
            if (this.$_.findIndex(this.data.resultList, {envDangerResultName: _item.envDangerResultName}) >= 0) {
              this.prevList.push(_item);
            } 
          }) 
          this.$_.forEach(this.data.resultList, _item => {
            let __idx = this.$_.findIndex(this.prevList, {envDangerResultName: _item.envDangerResultName})
            if (__idx >= 0) {
              _item.envDangerStock = this.prevList[__idx].envDangerStock
            }
          })
        }
      },);
    },
    gridchange() {
      let _columns = [
        {
          name: 'envDangerItemName',
          field: 'envDangerItemName',
          label: '점검항목',
          style: 'width:300px',
          align: 'left',
          sortable: false,
          fix: true,
        },
      ]

      this.resDate = [];
      var sDate = new Date(this.period[0])
      var eDate = new Date(this.period[1])
      while(sDate.getTime() <= eDate.getTime()) {
        var _mon = (sDate.getMonth()+1);
        _mon = _mon < 10 ? '0'+_mon : _mon;
        var _day_ = sDate.getDate();
        _day_ = _day_ < 10 ? '0'+_day_ : _day_;
        this.resDate.push(sDate.getFullYear() + '-' + _mon + '-' +  _day_);
        sDate.setDate(sDate.getDate() + 1);
      }

      let itemColumns = [];
      this.$comm.getComboItems('DANGER_RESULT_CD').then(_result => {
        this.$_.forEach(this.resDate, _item => {
          itemColumns.push({
            name: _item,
            field: _item,
            align: 'center',
            label: _item,
            type: 'select',
            isChip: true,
            none: true,
            style: 'width:100px',
            comboItems: _result,
            // setHeader: true,
            sortable: false,
          })
        })
        itemColumns.push({
          name: 'remark',
          field: 'remark',
          label: '비고',
          style: 'width:100px',
          type: 'textarea',
          align: 'left',
          sortable: false,
        })

        this.itemGrid.columns = this.$_.concat(_columns, itemColumns)
        
        if (!this.popupParam.envDangerJournalId) {
          this.getPrevDetail();
          if (this.data.envDangerMstId) {
            this.data.itemList = [];
            this.data.resultList = [];
            this.$http.url = this.$format(selectConfig.env.danger.master.get.url, this.data.envDangerMstId);
            this.$http.type = 'GET';
            this.$http.request((_result) => {
              if (_result.data.itemList) {
                this.$_.forEach(_result.data.itemList, _item =>{
                  this.data.itemList.push({
                    envDangerJournalId: this.popupParam.envDangerJournalId,
                    envDangerJournalItemId: uid(),
                    envDangerItemName: _item.envDangerItemName,
                    sortOrder: _item.sortOrder,
                    remark: _item.remark,
                    itemResultList: [],
                    editFlag: 'C',
                  })
                }) 
                this.$_.forEach(this.resDate, _item => {
                  this.$_.forEach(_result.data.typeList, __item => {
                    this.data.resultList.push({
                      envDangerJournalId: this.popupParam.envDangerJournalId,
                      envDangerJournalResultId: uid(),
                      envDangerResultDate: _item,
                      envDangerResultName: __item.envDangerTypeName,
                      calcuMethod: '재고량/'+ __item.calcuMethod,
                      envDangerIn: 0,
                      envDangerOut: 0,
                      envDangerStock: 0,
                      envDangerQuan: 0,
                      envDangerConfirmUserId: '',
                      envDangerConfirmUserName: '',
                      editFlag: 'C',
                    })
                  })
                  this.$_.forEach(this.data.itemList, __item => {
                    // 데이터에 표시하기 위함.
                    __item[_item] = "DR00000001";
                    // 날짜별 list
                    __item.itemResultList.push({
                      envDangerJournalId: this.popupParam.envDangerJournalId,
                      envDangerJournalItemId: __item.envDangerJournalItemId,
                      envDangerJournalItemResultId: uid(),
                      envDangerItemDate: _item,
                      envDangerEvalCd: null,
                      editFlag: 'C',
                    })
                  })
                })
                this.data.imprList = this.$_.cloneDeep(this.data.itemList)
              }
              this.getPrevDetail();
            },);
          }
          }
      });
    
    },
    saveJournal() {
      if (this.data.envDangerJournalId) {
        this.saveUrl = this.updateUrl;
        this.saveType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.saveType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          if (this.$comm.validTable(this.resultGrid.columns, this.data.resultList)) {
            window.getApp.$emit('CONFIRM', {
              title: '확인',
              message: '저장하시겠습니까?',
              // TODO : 필요시 추가하세요.
              type: 'info', // success / info / warning / error
              // 확인 callback 함수
              confirmCallback: () => {
                this.data.regUserId = this.$store.getters.user.userId
                this.data.chgUserId = this.$store.getters.user.userId
                
                if(this.saveType === 'POST') {
                  this.data.envDangerCompleteFlag = 'N'
                }
                if (this.period && this.period.length > 0) {
                  this.data.envDangerStartDate = this.period[0]
                  this.data.envDangerEndDate = this.period[1]
                }

                this.$_.forEach(this.data.itemList, _item => {
                  this.$_.forEach(_item.itemResultList, __item => {
                    __item.envDangerEvalCd = _item[__item.envDangerItemDate];
                    if (_item.editFlag === 'U') {
                      __item.editFlag = 'U'
                    }
                  })
                })
                this.isSave = !this.isSave;
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
          }
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      this.popupParam.envDangerJournalId = result.data
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    
    saveDataAppr() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '결재요청 하기 전 입력된 값을 저장합니다.\n\r 진행하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.data.regUserId = this.$store.getters.user.userId;
          this.data.chgUserId = this.$store.getters.user.userId;

          if (this.period && this.period.length > 0) {
            this.data.envDangerStartDate = this.period[0]
            this.data.envDangerEndDate = this.period[1]
          }

          this.$_.forEach(this.data.itemList, _item => {
            this.$_.forEach(_item.itemResultList, __item => {
              __item.envDangerEvalCd = _item[__item.envDangerItemDate];
              if (_item.editFlag === 'U') {
                __item.editFlag = 'U'
              }
            })
          })
          let promises = [
            {
              func: this.approvalValue
            },
          ];
          this.$comm.orderedPromise(promises);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    // [S] 결재관련 
    approvalCallback() { // 결재관련 결재요청버튼 callback
      this.$refs['appr-btn'].apprRequestPop();
    },
    approvalValue() {
      return new Promise(resolve => {
        this.isApproval = !this.isApproval
        resolve(true);
      });
    },
    removeData() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.envDangerJournalId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    searchDangerMaster() {
      this.popupOptions.title = '위험물 저장소 검색'; // 위험물 저장소 검색
      this.popupOptions.param = {
        type: 'single',
        plantCd: this.data.plantCd,
      };
      this.popupOptions.target = () => import(`${'./dangerMasterPop.vue'}`);
      this.popupOptions.width = '70%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeDangerPopup;
    },
    closeDangerPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.data.itemList = [];
        this.data.resultList = [];
        this.$http.url = this.$format(selectConfig.env.danger.master.get.url, data[0].envDangerMstId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.data.envDangerArea = _result.data.envDangerArea
          this.data.envDangerManageUserId = _result.data.envDangerManageUserId
          this.data.envDangerMstId = _result.data.envDangerMstId
          this.data.envDangerMstName = _result.data.envDangerMstName
          this.data.envDangerUserId = _result.data.envDangerUserId
          this.data.envDangerSafetyUserId = _result.data.envDangerSafetyUserId
          this.data.envDangerCount = _result.data.envDangerCount
          this.data.envDangerMainUse = _result.data.envDangerMainUse
          if (_result.data.itemList) {
            this.$_.forEach(_result.data.itemList, _item =>{
              this.data.itemList.push({
                envDangerJournalId: this.popupParam.envDangerJournalId,
                envDangerJournalItemId: uid(),
                envDangerItemName: _item.envDangerItemName,
                sortOrder: _item.sortOrder,
                remark: _item.remark,
                itemResultList: [],
                editFlag: 'C',
              })
            }) 
            this.$_.forEach(this.resDate, _item => {
              this.$_.forEach(_result.data.typeList, __item => {
                this.data.resultList.push({
                  envDangerJournalId: this.popupParam.envDangerJournalId,
                  envDangerJournalResultId: uid(),
                  envDangerResultDate: _item,
                  envDangerResultName: __item.envDangerTypeName,
                  calcuMethod: '재고량/'+ __item.calcuMethod,
                  envDangerIn: 0,
                  envDangerOut: 0,
                  envDangerStock: 0,
                  envDangerQuan: 0,
                  envDangerConfirmUserId: '',
                  envDangerConfirmUserName: '',
                  editFlag: 'C',
                })
              })
              this.$_.forEach(this.data.itemList, __item => {
                // 데이터에 표시하기 위함.
                __item[_item] = "DR00000001";
                // 날짜별 list
                __item.itemResultList.push({
                  envDangerJournalId: this.popupParam.envDangerJournalId,
                  envDangerJournalItemId: __item.envDangerJournalItemId,
                  envDangerJournalItemResultId: uid(),
                  envDangerItemDate: _item,
                  envDangerEvalCd: null,
                  editFlag: 'C',
                })
              })
            })
            this.data.imprList = this.$_.cloneDeep(this.data.itemList)
          }
          this.getPrevDetail();
        },);
      }
    },
    removeDangerMaster() {
      this.data.envDangerArea = '';
      this.data.envDangerManageUserId = '';
      this.data.envDangerMstName = '';
      this.data.envDangerUserId = '';
      this.data.envDangerSafetyUserId = '';
      this.data.envDangerCount = '';
      this.data.envDangerMainUse = '';
      this.data.itemList = [];
      this.data.resultList = [];
    },
  }
};
</script>
